// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero_wrapper__9ei+z","heroWrapper":"Hero_heroWrapper__7l4xw","content":"Hero_content__gQLV5"};